import React, { JSX, lazy, Suspense } from 'react';

const LazyHelpCenter = lazy(() => import('.'));

const HelpCenter = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyHelpCenter translations={undefined} {...props} />
  </Suspense>
);

export default HelpCenter;
